export default {
  id: 31,
  title: 'Target #31 - Equals',
  url: 'https://cssbattle.dev/play/31',
  colors: ['#AA445F', '#F7EC7D', '#E38F66'],
  solution:
    '<a a><a b><style>body{background:#aa445f}a{position:fixed;top:50;width:100;height:200}a[a]{left:75;background:#f7ec7d;border-radius:100px 0 0 100px}a[b]{right:75;background:#e38f66;border-radius:0 100px 100px 0}</style>',
}
